import { render, staticRenderFns } from "./Oauth2Redirect.vue?vue&type=template&id=2df16d1c&scoped=true"
import script from "./Oauth2Redirect.vue?vue&type=script&lang=js"
export * from "./Oauth2Redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df16d1c",
  null
  
)

export default component.exports